import { render, staticRenderFns } from "./associate-product-modal.vue?vue&type=template&id=350e5f49&scoped=true&"
import script from "./associate-product-modal.vue?vue&type=script&lang=js&"
export * from "./associate-product-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e5f49",
  null
  
)

export default component.exports